const $ = require('jquery');

class Preloader {
  constructor() {
    this.initiated = false;
    this.cursorIsVisible = false;
    this.preloader = $('#js-preload-pointer');
  }

  traceMouseForPreloader() {
    $('html,body').mousemove((event) => {
      const top = event.originalEvent.clientY;
      const left = event.originalEvent.clientX;
      this.preloader.css({ transform: `translate(${left}px, ${top}px)` });
    });

    this.initiated = true;
  }

  showCursorPreloader() {
    if (!this.initiated) {
      this.traceMouseForPreloader();
    }

    this.preloader.show();
    this.cursorIsVisible = true;
  }

  hideCursorPreloader() {
    this.preloader.hide();
    this.cursorIsVisible = false;
  }
}

module.exports = Preloader;
